<!-- 柱状图配置 -->
<template>
  <el-collapse accordion>
    <el-collapse-item title="分页设置">
      <el-form-item label="分页显示" label-width="120px">
        <el-switch @change="pageChange" v-model="main.activeOption.showPage" size="small"></el-switch>
      </el-form-item>
      <template v-if="main.activeOption.showPage">
        <el-form-item label="每页柱形数" label-width="120px">
          <el-input-number v-model="main.activeOption.pageSize" size="small"></el-input-number>
        </el-form-item>
        <el-form-item label="自动翻页" label-width="120px">
          <el-switch @change="autoPageChange" v-model="main.activeOption.autoPage" size="small"></el-switch>
        </el-form-item>
        <el-form-item v-if="main.activeOption.autoPage" label="自动翻页间隔(S)" label-width="120px">
          <el-input-number v-model="main.activeOption.pageInterval" size="small"></el-input-number>
        </el-form-item>
      </template>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: 'pageConfig',
  inject: ["main"],
  methods: {
    pageChange(v) {
      if (v) {
        this.main.activeOption.pageSize = 4
      }
    },
    autoPageChange() {
      this.main.activeOption.pageInterval = 4
    }
  }
}
</script>

<style>
</style>